/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { DrawerProps } from "@material-ui/core/Drawer";
import messages from "./DrawerMenu.intl";
import { injectIntl } from "react-intl";
import {
  Drawer,
  DrawerWrapper,
  DrawerHeader,
  CloseButton,
  DrawerContent,
} from "./DrawerElements";
import { styled } from "@material-ui/core/styles";
import { gql } from "@apollo/client";
import { useQuery, useMutation } from "@apollo/client";
import { Chip } from "@material-ui/core";
import SnackBar from "../../snackbar";
import { UserAvatarUploader } from "../../atoms";
import HeaderLogo from "../HeaderLogo";
// import LanguageSwitcher from "../../language-switcher";
import HomeIcon from "@material-ui/icons/HomeRounded";
import TeamsIcon from "@material-ui/icons/SupervisedUserCircleRounded";
import MatchIcon from "@material-ui/icons/SportsSoccerRounded";
import LibraryIcon from "@material-ui/icons/ImportContactsRounded";
import WorkIcon from "@material-ui/icons/Work";

import { actions } from "../../auth-context-provider";
import useAuthContext from "../../../hooks/useAuthContext";
import { FormattedMessage } from "react-intl";

import LogoutIcon from "@material-ui/icons/ExitToApp";
import { Link } from "@reach/router";
import useIsAdmin from "../../../hooks/useIsAdmin";
import Typography from "../../typography";

const StyledButton = styled("div")({
  display: "flex",
  width: "100%",
  backgroundColor: "#00BCD4",
  height: "140px",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10px",
  color: "white",
});
const StyledSmallButton = styled("div")({
  display: "flex",
  width: "100%",
  backgroundColor: "#00BCD4",
  height: "80px",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10px",
  color: "white",
});

const StyledLink = styled(Link)({
  width: "48%",
  height: "140px",
  paddingRight: "5px",
  marginTop: "5px",
  // color: "inherit",
  textDecoration: "inherit",
  zIndex: 600,
  display: "flex",
  backgroundColor: "#00BCD4",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10px",
  color: "white",
});

export const USER_QUERY = gql`
  query CurrentUser {
    currentUser {
      id
      name
      surname
      email
      role
      telephone
      workspace
      avatarUrl
    }
  }
`;

const STORE_SUBSCRIPTION = gql`
  mutation StoreSubscription(
    $endpoint: String!
    $auth: String!
    $p256dh: String!
  ) {
    storeSubscription(endpoint: $endpoint, auth: $auth, p256dh: $p256dh) {
      endpoint
      keys {
        auth
        p256dh
      }
    }
  }
`;

const ProfileDetails = injectIntl<DrawerProps>(({ open, onClose, intl }) => {
  const [currentUser, setCurrentUser] = useState<any>();
  // const [currentLocale, saveLocale] = useLocaleContext();
  const [isNotificationPresent] = useState("Notification" in window);

  const [state, dispatch] = useAuthContext();
  const { data, error } = useQuery(USER_QUERY, { skip: !open });
  const [storeSubscription] = useMutation(STORE_SUBSCRIPTION);

  // useEffect(() => {
  //   console.log("[serviceWorker]registering serviceWorker");
  //   serviceWorker.register();
  // }, []);

  useEffect(() => {
    if (data) {
      console.log("data------");
      console.log(data);
      setCurrentUser(data.currentUser);
    }
    if (error) {
      console.log("error loading user data", error);
    }
  }, [data]);

  const onCloseDrawer = (e = {}) => {
    if (onClose) {
      onClose(e, "backdropClick");
    }
  };

  const configurePubSub = () => {
    if (!("serviceWorker" in navigator)) {
      return;
    }
    let reg: any;
    navigator.serviceWorker.ready
      .then((swreg) => {
        reg = swreg;
        return swreg.pushManager.getSubscription();
      })
      .then((sub) => {
        console.log("[Subscription] existing...", sub);
        if (sub === null) {
          const vapidPublicKey =
            "BOu0p-iMA1DnWaInxevH-YWwBp1r8TX6bL7wgb5FGKIwaoC8h5hDmbFBhy6xPi-w4Fxl63O2DWqs_N8tyKzoPQ8";
          const convertedVapidPublicKey = urlBase64ToUint8(vapidPublicKey);
          return reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedVapidPublicKey,
          });
        } else {
        }
      })
      .then((newSub: any) => {
        //post to backend fetch or whatever...
        console.log("[Subscription]", JSON.parse(JSON.stringify(newSub)));
        return storeSubscription({
          variables: {
            endpoint: JSON.parse(JSON.stringify(newSub)).endpoint,
            auth: JSON.parse(JSON.stringify(newSub)).keys.auth,
            p256dh: JSON.parse(JSON.stringify(newSub)).keys.p256dh,
          },
        });
      })
      .then(() => {
        displayConfimNotification();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  function urlBase64ToUint8(base64String: string) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  const displayConfimNotification = () => {
    if ("serviceWorker" in navigator) {
      const options = {
        body: "Successfully Subscribed to Footik notifications",
        icon: "/images/icons/apple-icon-144x144.png",
        vibrate: [100, 50, 200],
        badge: "/images/icons/apple-icon-144x144.png",
        tag: "confirm-notification",
        renotify: true,
      };
      navigator.serviceWorker.ready.then(function(swreg) {
        console.log("SW ready");
        swreg.showNotification("Succesfully subscribed! (From SW)", options);
      });
    } else {
      console.log("no serviceWorker running");
    }
  };

  return (
    <>
      <Drawer open={open} onClose={onClose}>
        <DrawerWrapper data-testid="my-profile-details">
          <DrawerHeader>
            <HeaderLogo />
            {/* <DrawerTitle>
              Footik
            </DrawerTitle> */}
            {/* <LanguageSwitcher
              locale={currentLocale}
              onChange={saveLocale}
              locales={[
                { id: "en", label: "English (UK)" },
                { id: "en-GB", label: "Español (ES)" },
                // { id: "es_ES", label: "Spanish (ES)" }
              ]}
            /> */}
            <CloseButton
              onClick={onCloseDrawer}
              edge="end"
              aria-label={intl.formatMessage(messages.close)}
              data-testid="close-my-profile-details"
            />
          </DrawerHeader>
          {/* <Loader
            className={classes.root}
            // {...queryResult}
            loading={loading}
            error={error}
            errorMessage={intl.formatMessage(messages.loadUserError)}
          > */}
          {/* {({ currentUser }) => { */}
          {currentUser && (
            <DrawerContent scrollable={true}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <UserAvatarUploader
                  style={{ width: 80, height: 80, fontSize: "3rem" }}
                  user={{
                    name: (currentUser && currentUser.name) || "F",
                    surname: (currentUser && currentUser.surname) || "O",
                    email: (currentUser && currentUser.email) || "",
                    avatarUrl: (currentUser && currentUser.avatarUrl) || "",
                  }}
                />
                {state && state.user && (
                  <Typography.H6
                    style={{ fontWeight: 100 }}
                  >{`${state.user.name} ${state.user.surname}`}</Typography.H6>
                )}
                <Chip
                  icon={<WorkIcon fontSize="small" />}
                  variant="outlined"
                  label={`Workspce: ${currentUser.workspace}`}
                  onClick={() => null}
                  color="primary"
                  style={{ borderRadius: 18, padding: "3px" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "8px",
                  justifyContent: "space-around",
                }}
              >
                <StyledLink to="/">
                  <HomeIcon fontSize="large" />
                </StyledLink>
                <StyledLink to="/people/matches">
                  <MatchIcon fontSize="large" />
                </StyledLink>

                {useIsAdmin() && (
                  <StyledLink to="/library/exercises">
                    <LibraryIcon fontSize="large" />
                  </StyledLink>
                )}

                <StyledLink to="/people/players">
                  <TeamsIcon fontSize="large" />
                </StyledLink>
              </div>
              <div
                style={{
                  marginTop: "8px",
                }}
              >
                <StyledButton
                  onClick={() => dispatch(actions.logout())}
                  data-testid="user-menu-logout"
                  style={{ backgroundColor: "#FF5722" }}
                >
                  <FormattedMessage {...messages.logout} />
                  <LogoutIcon fontSize="large" />
                </StyledButton>
              </div>
              {isNotificationPresent && (
                <div
                  style={{
                    marginTop: "8px",
                  }}
                >
                  <StyledSmallButton
                    onClick={() => {
                      Notification.requestPermission((result) => {
                        console.log("[Noti] User choice", result);
                        if (result !== "granted") {
                          console.log(
                            "[Noti] no notification permission granted"
                          );
                        } else {
                          // displayConfimNotification();
                          configurePubSub();
                        }
                      });
                    }}
                    data-testid="user-menu-logout"
                    style={{ backgroundColor: "#22ffcc" }}
                  >
                    Request Permission
                    <LogoutIcon fontSize="large" />
                  </StyledSmallButton>
                </div>
              )}
            </DrawerContent>
          )}
        </DrawerWrapper>
      </Drawer>
      <SnackBar
        data-testid="snackbar-error-message"
        open={false}
        // open={showUpdateError}
        message={intl.formatMessage(messages.updateUserError)}
        variant="error"
        onClose={
          // onClose is called by SnackBar after 6s
          /* istanbul ignore next */ () => {
            // setShowUpdateError(false);
          }
        }
      />
    </>
  );
});

export default ProfileDetails;
